export const getId = () => `node_${Date.now()}`;
